module.exports = __webpack_public_path__ + "static/media/etiketointi-1.95ca6c59.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./media/videos/etiketointi-1.mp4
 ** module id = 448
 ** module chunks = 0
 **/